/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AviAlertBellModule
 */

import {
    Component,
    EventEmitter,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import * as globalL10n from 'global-l10n';
import './avi-alert-bell-footer.component.less';

const { ENGLISH: dictionary, ...globalL10nKeys } = globalL10n;

/**
 * @description Component to render the footer for alert bell.
 * @author Umesh Chovatiya
 */
@Component({
    selector: 'avi-alert-bell-footer',
    templateUrl: './avi-alert-bell-footer.component.html',
})
export class AviAlertBellFooterComponent {
    /**
     * Fire on click of View All Alerts button.
     */
    @Output()
    public onViewAllAlertsClick = new EventEmitter<void>();

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Trigger retry click event.
     */
    public handleViewAllAlertsClick(): void {
        this.onViewAllAlertsClick.emit();
    }
}
